import { Expose } from "class-transformer";

export class CreateManufacturerDto {
  @Expose()
  name: string;
}
